import {combineReducers} from "redux";

export function error(state = null, action) {
    switch (action.type) {
        case "PRODUCT_CREATE_ERROR":
            return action.error;

        case "PRODUCT_CREATE_RESET":
            return null;

        default:
            return state;
    }
}

export function loading(state = false, action) {
    switch (action.type) {
        case "PRODUCT_CREATE_LOADING":
            return action.loading;

        case "PRODUCT_CREATE_RESET":
            return null;

        default:
            return state;
    }
}

export function retrieved(state = false, action) {
    switch (action.type) {
        case "PRODUCT_CREATE_SUCCESS":
            return action.retrieved;

        case "PRODUCT_CREATE_RESET":
            return null;

        default:
            return state;
    }
}

export default combineReducers({error, loading, retrieved});